/* ─── Contact Page — Cose Belle Cose Rare ─── */

(function () {
  'use strict';

  class ContactPage {
    constructor(sectionId) {
      this.sectionId = sectionId;

      // Form elements
      this.form        = document.getElementById('ContactForm');
      this.fieldsWrap  = document.getElementById(`ct-form-fields-${sectionId}`);
      this.successWrap = document.getElementById(`ct-success-${sectionId}`);
      this.privCheck   = document.getElementById(`ct-privacy-check-${sectionId}`);
      this.privInput   = document.getElementById(`ct-privacy-input-${sectionId}`);
      this.submitBtn   = document.getElementById(`ct-submit-btn-${sectionId}`);

      // Char counters
      this.charLimit = (window.ContactPageData?.[sectionId]?.charLimit) || 1000;

      if (!this.form) return;

      this._bindPrivacy();
      this._bindCharCounters();
      this._bindForm();
      this._bindSuccessBack();
    }

    _bindPrivacy() {
      if (!this.privCheck) return;

      const updateSubmitState = (checked) => {
        if (this.submitBtn) {
          this.submitBtn.disabled = !checked;
          this.submitBtn.setAttribute('aria-disabled', checked ? 'false' : 'true');
        }
      };

      const toggle = () => {
        const isChecked = this.privCheck.getAttribute('aria-checked') === 'true';
        const newState = !isChecked;
        this.privCheck.setAttribute('aria-checked', newState ? 'true' : 'false');
        if (this.privInput) {
          this.privInput.value = newState ? 'yes' : 'no';
        }
        updateSubmitState(newState);
      };

      // Stato iniziale: submit disabilitato
      updateSubmitState(false);

      // Click sul checkbox
      this.privCheck.addEventListener('click', toggle);

      // Click sul testo privacy (ma non su link)
      const privRow = this.privCheck.closest('.ct-privacy');
      if (privRow) {
        privRow.addEventListener('click', (e) => {
          if (e.target === this.privCheck || this.privCheck.contains(e.target)) return;
          if (e.target.tagName === 'A') return;
          toggle();
        });
      }

      // Tastiera
      this.privCheck.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    }

    _bindCharCounters() {
      document.querySelectorAll('.ct-char-count').forEach((counter) => {
        const targetId = counter.dataset.target;
        const textarea = document.getElementById(targetId);
        if (!textarea) return;

        const limit = parseInt(textarea.dataset.charLimit, 10) || this.charLimit;

        const update = () => {
          const len = textarea.value.length;
          counter.textContent = `${len} / ${limit}`;
          counter.style.color = len >= limit * 0.9 ? '#c9a84c' : '#ccc';
        };

        textarea.addEventListener('input', update);
        update();
      });
    }

    _bindForm() {
      if (!this.form) return;

      // Rimuovi hash dall'action per evitare page scroll dopo redirect
      if (this.form.action.includes('#')) {
        this.form.action = this.form.action.split('#')[0];
      }

      // Submit nativo — mostra animazione loading sul bottone
      this.form.addEventListener('submit', () => {
        if (this.submitBtn) {
          this.submitBtn.classList.add('is-loading');
        }
        // Non fare preventDefault — lascia il submit nativo andare
      });
    }

    _showSuccess() {
      if (this.fieldsWrap) this.fieldsWrap.classList.add('is-hidden');
      if (this.successWrap) {
        this.successWrap.classList.add('is-visible');
        this.successWrap.setAttribute('aria-hidden', 'false');
      }
    }

    _bindSuccessBack() {
      const submitLabel = this.submitBtn?.textContent?.trim() || 'Send message →';

      document.querySelectorAll('.ct-success__back').forEach((btn) => {
        if (btn.dataset.section !== this.sectionId) return;
        btn.addEventListener('click', () => {
          if (this.fieldsWrap) this.fieldsWrap.classList.remove('is-hidden');
          if (this.successWrap) {
            this.successWrap.classList.remove('is-visible');
            this.successWrap.setAttribute('aria-hidden', 'true');
          }
          // Reset form e privacy
          this.form?.reset();
          if (this.privCheck) {
            this.privCheck.setAttribute('aria-checked', 'false');
          }
          if (this.privInput) {
            this.privInput.value = 'no';
          }
          if (this.submitBtn) {
            this.submitBtn.disabled = true;
            this.submitBtn.setAttribute('aria-disabled', 'true');
            this.submitBtn.textContent = submitLabel;
          }
        });
      });
    }
  }

  function initAll() {
    if (!window.ContactPageData) return;
    Object.keys(window.ContactPageData).forEach(id => {
      new ContactPage(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', (e) => {
    if (window.ContactPageData?.[e.detail.sectionId]) {
      new ContactPage(e.detail.sectionId);
    }
  });

})();
